export default __webpack_public_path__ + "static/media/master-bg.9c8cd3d3.png";